/*  When creating vanilla routes, 
    you need to ensure they are unique and
    not substrings of other routes */
export const VANILLA_ROUTES = [
  '/ui/#/vanillaApp',
  '/ui/#/assessment-view',
  '/ui/#/contentProvider',
  '/ui/#/ltierror',
  '/ui/#/picker',
  '/ui/#/classcraft',
  '/ui/#/mapgrowth-monitoring',
  '/ui/#/mapgrowth-view',
];
export const EXCLUDE_PENDO_ROUTE = [
  '/ui/#/vanillaApp',
  '/ui/#/assessment-view',
  '/ui/#/contentProvider',
  '/ui/#/ltierror',
  '/ui/#/classcraft/participate',
  '/ui/#/ai-tools',
];

export const VANILLA_ROUTE_EXCLUSIONS = [
  'mainNavigation',
  'userProfile',
  'trainingPath',
  'coachingCore',
  'coachingChat',
];
